import { render, staticRenderFns } from "./MessagesList.vue?vue&type=template&id=4e39b578&scoped=true&lang=pug"
import script from "./MessagesList.vue?vue&type=script&lang=js"
export * from "./MessagesList.vue?vue&type=script&lang=js"
import style0 from "./MessagesList.vue?vue&type=style&index=0&id=4e39b578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e39b578",
  null
  
)

export default component.exports